export const phoneList = [
  {
    name: "Afghanistan",
    callingCodes: "+93",
    flags: {
      svg: "https://upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_the_Taliban.svg",
      png: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Flag_of_the_Taliban.svg/320px-Flag_of_the_Taliban.svg.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Åland Islands",
    callingCodes: "+358",
    flags: {
      svg: "https://flagcdn.com/ax.svg",
      png: "https://flagcdn.com/w320/ax.png",
    },
    independent: false,
  },
  {
    name: "Albania",
    callingCodes: "+355",
    flags: {
      svg: "https://flagcdn.com/al.svg",
      png: "https://flagcdn.com/w320/al.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Algeria",
    callingCodes: "+213",
    flags: {
      svg: "https://flagcdn.com/dz.svg",
      png: "https://flagcdn.com/w320/dz.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "American Samoa",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/as.svg",
      png: "https://flagcdn.com/w320/as.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Andorra",
    callingCodes: "+376",
    flags: {
      svg: "https://flagcdn.com/ad.svg",
      png: "https://flagcdn.com/w320/ad.png",
    },
    independent: false,
    phoneLength: 6,
  },
  {
    name: "Angola",
    callingCodes: "+244",
    flags: {
      svg: "https://flagcdn.com/ao.svg",
      png: "https://flagcdn.com/w320/ao.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Anguilla",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/ai.svg",
      png: "https://flagcdn.com/w320/ai.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Antarctica",
    callingCodes: "+672",
    flags: {
      svg: "https://flagcdn.com/aq.svg",
      png: "https://flagcdn.com/w320/aq.png",
    },
    independent: false,
    phoneLength: 6,
  },
  {
    name: "Antigua and Barbuda",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/ag.svg",
      png: "https://flagcdn.com/w320/ag.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Argentina",
    callingCodes: "+54",
    flags: {
      svg: "https://flagcdn.com/ar.svg",
      png: "https://flagcdn.com/w320/ar.png",
    },
    independent: false,
    phoneLength: [6, 7, 8],
  },
  {
    name: "Armenia",
    callingCodes: "+374",
    flags: {
      svg: "https://flagcdn.com/am.svg",
      png: "https://flagcdn.com/w320/am.png",
    },
    independent: false,
    phoneLength: 6,
  },
  {
    name: "Aruba",
    callingCodes: "+297",
    flags: {
      svg: "https://flagcdn.com/aw.svg",
      png: "https://flagcdn.com/w320/aw.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Australia",
    callingCodes: "+61",
    flags: {
      svg: "https://flagcdn.com/au.svg",
      png: "https://flagcdn.com/w320/au.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Austria",
    callingCodes: "+43",
    flags: {
      svg: "https://flagcdn.com/at.svg",
      png: "https://flagcdn.com/w320/at.png",
    },
    independent: false,
    phoneLength: [10, 11],
  },
  {
    name: "Azerbaijan",
    callingCodes: "+994",
    flags: {
      svg: "https://flagcdn.com/az.svg",
      png: "https://flagcdn.com/w320/az.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Bahamas",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/bs.svg",
      png: "https://flagcdn.com/w320/bs.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Bahrain",
    callingCodes: "+973",
    flags: {
      svg: "https://flagcdn.com/bh.svg",
      png: "https://flagcdn.com/w320/bh.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Bangladesh",
    callingCodes: "+880",
    flags: {
      svg: "https://flagcdn.com/bd.svg",
      png: "https://flagcdn.com/w320/bd.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Barbados",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/bb.svg",
      png: "https://flagcdn.com/w320/bb.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Belarus",
    callingCodes: "+375",
    flags: {
      svg: "https://flagcdn.com/by.svg",
      png: "https://flagcdn.com/w320/by.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Belgium",
    callingCodes: "+32",
    flags: {
      svg: "https://flagcdn.com/be.svg",
      png: "https://flagcdn.com/w320/be.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Belize",
    callingCodes: "+501",
    flags: {
      svg: "https://flagcdn.com/bz.svg",
      png: "https://flagcdn.com/w320/bz.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Benin",
    callingCodes: "+229",
    flags: {
      svg: "https://flagcdn.com/bj.svg",
      png: "https://flagcdn.com/w320/bj.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Bermuda",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/bm.svg",
      png: "https://flagcdn.com/w320/bm.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Bhutan",
    callingCodes: "+975",
    flags: {
      svg: "https://flagcdn.com/bt.svg",
      png: "https://flagcdn.com/w320/bt.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Bolivia (Plurinational State of)",
    callingCodes: "+591",
    flags: {
      svg: "https://flagcdn.com/bo.svg",
      png: "https://flagcdn.com/w320/bo.png",
    },
    independent: false,
  },
  {
    name: "Bonaire, Sint Eustatius and Saba",
    callingCodes: "+599",
    flags: {
      svg: "https://flagcdn.com/bq.svg",
      png: "https://flagcdn.com/w320/bq.png",
    },
    independent: false,
  },
  {
    name: "Bosnia and Herzegovina",
    callingCodes: "+387",
    flags: {
      svg: "https://flagcdn.com/ba.svg",
      png: "https://flagcdn.com/w320/ba.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Botswana",
    callingCodes: "+267",
    flags: {
      svg: "https://flagcdn.com/bw.svg",
      png: "https://flagcdn.com/w320/bw.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Bouvet Island",
    callingCodes: "+47",
    flags: {
      svg: "https://flagcdn.com/bv.svg",
      png: "https://flagcdn.com/w320/bv.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Brazil",
    callingCodes: "+55",
    flags: {
      svg: "https://flagcdn.com/br.svg",
      png: "https://flagcdn.com/w320/br.png",
    },
    independent: false,
    phoneLength: 11,
  },
  {
    name: "British Indian Ocean Territory",
    callingCodes: "+246",
    flags: {
      svg: "https://flagcdn.com/io.svg",
      png: "https://flagcdn.com/w320/io.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "United States Minor Outlying Islands",
    callingCodes: "+246",
    flags: {
      svg: "https://flagcdn.com/um.svg",
      png: "https://flagcdn.com/w320/um.png",
    },
    independent: false,
  },
  {
    name: "Virgin Islands (British)",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/vg.svg",
      png: "https://flagcdn.com/w320/vg.png",
    },
    independent: false,
  },
  {
    name: "Virgin Islands (U.S.)",
    callingCodes: "+1 340",
    flags: {
      svg: "https://flagcdn.com/vi.svg",
      png: "https://flagcdn.com/w320/vi.png",
    },
    independent: false,
  },
  {
    name: "Brunei Darussalam",
    callingCodes: "+673",
    flags: {
      svg: "https://flagcdn.com/bn.svg",
      png: "https://flagcdn.com/w320/bn.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Bulgaria",
    callingCodes: "+359",
    flags: {
      svg: "https://flagcdn.com/bg.svg",
      png: "https://flagcdn.com/w320/bg.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Burkina Faso",
    callingCodes: "+226",
    flags: {
      svg: "https://flagcdn.com/bf.svg",
      png: "https://flagcdn.com/w320/bf.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Burundi",
    callingCodes: "+257",
    flags: {
      svg: "https://flagcdn.com/bi.svg",
      png: "https://flagcdn.com/w320/bi.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Cambodia",
    callingCodes: "+855",
    flags: {
      svg: "https://flagcdn.com/kh.svg",
      png: "https://flagcdn.com/w320/kh.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Cameroon",
    callingCodes: "+237",
    flags: {
      svg: "https://flagcdn.com/cm.svg",
      png: "https://flagcdn.com/w320/cm.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Canada",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/ca.svg",
      png: "https://flagcdn.com/w320/ca.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Cabo Verde",
    callingCodes: "+238",
    flags: {
      svg: "https://flagcdn.com/cv.svg",
      png: "https://flagcdn.com/w320/cv.png",
    },
    independent: false,
  },
  {
    name: "Cayman Islands",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/ky.svg",
      png: "https://flagcdn.com/w320/ky.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Central African Republic",
    callingCodes: "+236",
    flags: {
      svg: "https://flagcdn.com/cf.svg",
      png: "https://flagcdn.com/w320/cf.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Chad",
    callingCodes: "+235",
    flags: {
      svg: "https://flagcdn.com/td.svg",
      png: "https://flagcdn.com/w320/td.png",
    },
    independent: false,
    phoneLength: 6,
  },
  {
    name: "Chile",
    callingCodes: "+56",
    flags: {
      svg: "https://flagcdn.com/cl.svg",
      png: "https://flagcdn.com/w320/cl.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "China",
    callingCodes: "+86",
    flags: {
      svg: "https://flagcdn.com/cn.svg",
      png: "https://flagcdn.com/w320/cn.png",
    },
    independent: false,
    phoneLength: 11,
  },
  {
    name: "Christmas Island",
    callingCodes: "+61",
    flags: {
      svg: "https://flagcdn.com/cx.svg",
      png: "https://flagcdn.com/w320/cx.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Cocos (Keeling) Islands",
    callingCodes: "+61",
    flags: {
      svg: "https://flagcdn.com/cc.svg",
      png: "https://flagcdn.com/w320/cc.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Colombia",
    callingCodes: "+57",
    flags: {
      svg: "https://flagcdn.com/co.svg",
      png: "https://flagcdn.com/w320/co.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Comoros",
    callingCodes: "+269",
    flags: {
      svg: "https://flagcdn.com/km.svg",
      png: "https://flagcdn.com/w320/km.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Congo",
    callingCodes: "+242",
    flags: {
      svg: "https://flagcdn.com/cg.svg",
      png: "https://flagcdn.com/w320/cg.png",
    },
    independent: false,
  },
  {
    name: "Congo (Democratic Republic of the)",
    callingCodes: "+243",
    flags: {
      svg: "https://flagcdn.com/cd.svg",
      png: "https://flagcdn.com/w320/cd.png",
    },
    independent: false,
  },
  {
    name: "Cook Islands",
    callingCodes: "+682",
    flags: {
      svg: "https://flagcdn.com/ck.svg",
      png: "https://flagcdn.com/w320/ck.png",
    },
    independent: false,
    phoneLength: 5,
  },
  {
    name: "Costa Rica",
    callingCodes: "+506",
    flags: {
      svg: "https://flagcdn.com/cr.svg",
      png: "https://flagcdn.com/w320/cr.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Croatia",
    callingCodes: "+385",
    flags: {
      svg: "https://flagcdn.com/hr.svg",
      png: "https://flagcdn.com/w320/hr.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Cuba",
    callingCodes: "+53",
    flags: {
      svg: "https://flagcdn.com/cu.svg",
      png: "https://flagcdn.com/w320/cu.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Curaçao",
    callingCodes: "+599",
    flags: {
      svg: "https://flagcdn.com/cw.svg",
      png: "https://flagcdn.com/w320/cw.png",
    },
    independent: false,
  },
  {
    name: "Cyprus",
    callingCodes: "+357",
    flags: {
      svg: "https://flagcdn.com/cy.svg",
      png: "https://flagcdn.com/w320/cy.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Czech Republic",
    callingCodes: "+420",
    flags: {
      svg: "https://flagcdn.com/cz.svg",
      png: "https://flagcdn.com/w320/cz.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Denmark",
    callingCodes: "+45",
    flags: {
      svg: "https://flagcdn.com/dk.svg",
      png: "https://flagcdn.com/w320/dk.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Djibouti",
    callingCodes: "+253",
    flags: {
      svg: "https://flagcdn.com/dj.svg",
      png: "https://flagcdn.com/w320/dj.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Dominica",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/dm.svg",
      png: "https://flagcdn.com/w320/dm.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Dominican Republic",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/do.svg",
      png: "https://flagcdn.com/w320/do.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Ecuador",
    callingCodes: "+593",
    flags: {
      svg: "https://flagcdn.com/ec.svg",
      png: "https://flagcdn.com/w320/ec.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Egypt",
    callingCodes: "+20",
    flags: {
      svg: "https://flagcdn.com/eg.svg",
      png: "https://flagcdn.com/w320/eg.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "El Salvador",
    callingCodes: "+503",
    flags: {
      svg: "https://flagcdn.com/sv.svg",
      png: "https://flagcdn.com/w320/sv.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Equatorial Guinea",
    callingCodes: "+240",
    flags: {
      svg: "https://flagcdn.com/gq.svg",
      png: "https://flagcdn.com/w320/gq.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Eritrea",
    callingCodes: "+291",
    flags: {
      svg: "https://flagcdn.com/er.svg",
      png: "https://flagcdn.com/w320/er.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Estonia",
    callingCodes: "+372",
    flags: {
      svg: "https://flagcdn.com/ee.svg",
      png: "https://flagcdn.com/w320/ee.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Ethiopia",
    callingCodes: "+251",
    flags: {
      svg: "https://flagcdn.com/et.svg",
      png: "https://flagcdn.com/w320/et.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Falkland Islands (Malvinas)",
    callingCodes: "+500",
    flags: {
      svg: "https://flagcdn.com/fk.svg",
      png: "https://flagcdn.com/w320/fk.png",
    },
    independent: false,
    phoneLength: 5,
  },
  {
    name: "Faroe Islands",
    callingCodes: "+298",
    flags: {
      svg: "https://flagcdn.com/fo.svg",
      png: "https://flagcdn.com/w320/fo.png",
    },
    independent: false,
    phoneLength: 5,
  },
  {
    name: "Fiji",
    callingCodes: "+679",
    flags: {
      svg: "https://flagcdn.com/fj.svg",
      png: "https://flagcdn.com/w320/fj.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Finland",
    callingCodes: "+358",
    flags: {
      svg: "https://flagcdn.com/fi.svg",
      png: "https://flagcdn.com/w320/fi.png",
    },
    independent: false,
  },
  {
    name: "France",
    callingCodes: "+33",
    flags: {
      svg: "https://flagcdn.com/fr.svg",
      png: "https://flagcdn.com/w320/fr.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "French Guiana",
    callingCodes: "+594",
    flags: {
      svg: "https://flagcdn.com/gf.svg",
      png: "https://flagcdn.com/w320/gf.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "French Polynesia",
    callingCodes: "+689",
    flags: {
      svg: "https://flagcdn.com/pf.svg",
      png: "https://flagcdn.com/w320/pf.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "French Southern Territories",
    callingCodes: "+262",
    flags: {
      svg: "https://flagcdn.com/tf.svg",
      png: "https://flagcdn.com/w320/tf.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Gabon",
    callingCodes: "+241",
    flags: {
      svg: "https://flagcdn.com/ga.svg",
      png: "https://flagcdn.com/w320/ga.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Gambia",
    callingCodes: "+220",
    flags: {
      svg: "https://flagcdn.com/gm.svg",
      png: "https://flagcdn.com/w320/gm.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Georgia",
    callingCodes: "+995",
    flags: {
      svg: "https://flagcdn.com/ge.svg",
      png: "https://flagcdn.com/w320/ge.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Germany",
    callingCodes: "+49",
    flags: {
      svg: "https://flagcdn.com/de.svg",
      png: "https://flagcdn.com/w320/de.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Ghana",
    callingCodes: "+233",
    flags: {
      svg: "https://flagcdn.com/gh.svg",
      png: "https://flagcdn.com/w320/gh.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Gibraltar",
    callingCodes: "+350",
    flags: {
      svg: "https://flagcdn.com/gi.svg",
      png: "https://flagcdn.com/w320/gi.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Greece",
    callingCodes: "+30",
    flags: {
      svg: "https://flagcdn.com/gr.svg",
      png: "https://flagcdn.com/w320/gr.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Greenland",
    callingCodes: "+299",
    flags: {
      svg: "https://flagcdn.com/gl.svg",
      png: "https://flagcdn.com/w320/gl.png",
    },
    independent: false,
    phoneLength: 6,
  },
  {
    name: "Grenada",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/gd.svg",
      png: "https://flagcdn.com/w320/gd.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Guadeloupe",
    callingCodes: "+590",
    flags: {
      svg: "https://flagcdn.com/gp.svg",
      png: "https://flagcdn.com/w320/gp.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Guam",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/gu.svg",
      png: "https://flagcdn.com/w320/gu.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Guatemala",
    callingCodes: "+502",
    flags: {
      svg: "https://flagcdn.com/gt.svg",
      png: "https://flagcdn.com/w320/gt.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Guernsey",
    callingCodes: "+44",
    flags: {
      svg: "https://flagcdn.com/gg.svg",
      png: "https://flagcdn.com/w320/gg.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Guinea",
    callingCodes: "+224",
    flags: {
      svg: "https://flagcdn.com/gn.svg",
      png: "https://flagcdn.com/w320/gn.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Guinea-Bissau",
    callingCodes: "+245",
    flags: {
      svg: "https://flagcdn.com/gw.svg",
      png: "https://flagcdn.com/w320/gw.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Guyana",
    callingCodes: "+592",
    flags: {
      svg: "https://flagcdn.com/gy.svg",
      png: "https://flagcdn.com/w320/gy.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Haiti",
    callingCodes: "+509",
    flags: {
      svg: "https://flagcdn.com/ht.svg",
      png: "https://flagcdn.com/w320/ht.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Heard Island and McDonald Islands",
    callingCodes: "+672",
    flags: {
      svg: "https://flagcdn.com/hm.svg",
      png: "https://flagcdn.com/w320/hm.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Vatican City",
    callingCodes: "+379",
    flags: {
      svg: "https://flagcdn.com/va.svg",
      png: "https://flagcdn.com/w320/va.png",
    },
    independent: false,
  },
  {
    name: "Honduras",
    callingCodes: "+504",
    flags: {
      svg: "https://flagcdn.com/hn.svg",
      png: "https://flagcdn.com/w320/hn.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Hungary",
    callingCodes: "+36",
    flags: {
      svg: "https://flagcdn.com/hu.svg",
      png: "https://flagcdn.com/w320/hu.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Hong Kong",
    callingCodes: "+852",
    flags: {
      svg: "https://flagcdn.com/hk.svg",
      png: "https://flagcdn.com/w320/hk.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Iceland",
    callingCodes: "+354",
    flags: {
      svg: "https://flagcdn.com/is.svg",
      png: "https://flagcdn.com/w320/is.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "India",
    callingCodes: "+91",
    flags: {
      svg: "https://flagcdn.com/in.svg",
      png: "https://flagcdn.com/w320/in.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Indonesia",
    callingCodes: "+62",
    flags: {
      svg: "https://flagcdn.com/id.svg",
      png: "https://flagcdn.com/w320/id.png",
    },
    independent: false,
    phoneLength: 11,
  },
  {
    name: "Ivory Coast",
    callingCodes: "+225",
    flags: {
      svg: "https://flagcdn.com/ci.svg",
      png: "https://flagcdn.com/w320/ci.png",
    },
    independent: false,
  },
  {
    name: "Iran (Islamic Republic of)",
    callingCodes: "+98",
    flags: {
      svg: "https://flagcdn.com/ir.svg",
      png: "https://flagcdn.com/w320/ir.png",
    },
    independent: false,
  },
  {
    name: "Iraq",
    callingCodes: "+964",
    flags: {
      svg: "https://flagcdn.com/iq.svg",
      png: "https://flagcdn.com/w320/iq.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Ireland",
    callingCodes: "+353",
    flags: {
      svg: "https://flagcdn.com/ie.svg",
      png: "https://flagcdn.com/w320/ie.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Isle of Man",
    callingCodes: "+44",
    flags: {
      svg: "https://flagcdn.com/im.svg",
      png: "https://flagcdn.com/w320/im.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Israel",
    callingCodes: "+972",
    flags: {
      svg: "https://flagcdn.com/il.svg",
      png: "https://flagcdn.com/w320/il.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Italy",
    callingCodes: "+39",
    flags: {
      svg: "https://flagcdn.com/it.svg",
      png: "https://flagcdn.com/w320/it.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Jamaica",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/jm.svg",
      png: "https://flagcdn.com/w320/jm.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Japan",
    callingCodes: "+81",
    flags: {
      svg: "https://flagcdn.com/jp.svg",
      png: "https://flagcdn.com/w320/jp.png",
    },
    independent: false,
  },
  {
    name: "Jersey",
    callingCodes: "+44",
    flags: {
      svg: "https://flagcdn.com/je.svg",
      png: "https://flagcdn.com/w320/je.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Jordan",
    callingCodes: "+962",
    flags: {
      svg: "https://flagcdn.com/jo.svg",
      png: "https://flagcdn.com/w320/jo.png",
    },
    independent: false,
    phoneLength: [8, 9],
  },
  {
    name: "Kazakhstan",
    callingCodes: "+76",
    flags: {
      svg: "https://flagcdn.com/kz.svg",
      png: "https://flagcdn.com/w320/kz.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Kenya",
    callingCodes: "+254",
    flags: {
      svg: "https://flagcdn.com/ke.svg",
      png: "https://flagcdn.com/w320/ke.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Kiribati",
    callingCodes: "+686",
    flags: {
      svg: "https://flagcdn.com/ki.svg",
      png: "https://flagcdn.com/w320/ki.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Kuwait",
    callingCodes: "+965",
    flags: {
      svg: "https://flagcdn.com/kw.svg",
      png: "https://flagcdn.com/w320/kw.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Kyrgyzstan",
    callingCodes: "+996",
    flags: {
      svg: "https://flagcdn.com/kg.svg",
      png: "https://flagcdn.com/w320/kg.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Lao People's Democratic Republic",
    callingCodes: "+856",
    flags: {
      svg: "https://flagcdn.com/la.svg",
      png: "https://flagcdn.com/w320/la.png",
    },
    independent: false,
    phoneLength: [8, 9],
  },
  {
    name: "Latvia",
    callingCodes: "+371",
    flags: {
      svg: "https://flagcdn.com/lv.svg",
      png: "https://flagcdn.com/w320/lv.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Lebanon",
    callingCodes: "+961",
    flags: {
      svg: "https://flagcdn.com/lb.svg",
      png: "https://flagcdn.com/w320/lb.png",
    },
    independent: false,
    phoneLength: [7, 8],
  },
  {
    name: "Lesotho",
    callingCodes: "+266",
    flags: {
      svg: "https://flagcdn.com/ls.svg",
      png: "https://flagcdn.com/w320/ls.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Liberia",
    callingCodes: "+231",
    flags: {
      svg: "https://flagcdn.com/lr.svg",
      png: "https://flagcdn.com/w320/lr.png",
    },
    independent: false,
    phoneLength: [8, 9],
  },
  {
    name: "Libya",
    callingCodes: "+218",
    flags: {
      svg: "https://flagcdn.com/ly.svg",
      png: "https://flagcdn.com/w320/ly.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Liechtenstein",
    callingCodes: "+423",
    flags: {
      svg: "https://flagcdn.com/li.svg",
      png: "https://flagcdn.com/w320/li.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Lithuania",
    callingCodes: "+370",
    flags: {
      svg: "https://flagcdn.com/lt.svg",
      png: "https://flagcdn.com/w320/lt.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Luxembourg",
    callingCodes: "+352",
    flags: {
      svg: "https://flagcdn.com/lu.svg",
      png: "https://flagcdn.com/w320/lu.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Macao",
    callingCodes: "+853",
    flags: {
      svg: "https://flagcdn.com/mo.svg",
      png: "https://flagcdn.com/w320/mo.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "North Macedonia",
    callingCodes: "+389",
    flags: {
      svg: "https://flagcdn.com/mk.svg",
      png: "https://flagcdn.com/w320/mk.png",
    },
    independent: false,
  },
  {
    name: "Madagascar",
    callingCodes: "+261",
    flags: {
      svg: "https://flagcdn.com/mg.svg",
      png: "https://flagcdn.com/w320/mg.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Malawi",
    callingCodes: "+265",
    flags: {
      svg: "https://flagcdn.com/mw.svg",
      png: "https://flagcdn.com/w320/mw.png",
    },
    independent: false,
    phoneLength: [7, 8, 9],
  },
  {
    name: "Malaysia",
    callingCodes: "+60",
    flags: {
      svg: "https://flagcdn.com/my.svg",
      png: "https://flagcdn.com/w320/my.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Maldives",
    callingCodes: "+960",
    flags: {
      svg: "https://flagcdn.com/mv.svg",
      png: "https://flagcdn.com/w320/mv.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Mali",
    callingCodes: "+223",
    flags: {
      svg: "https://flagcdn.com/ml.svg",
      png: "https://flagcdn.com/w320/ml.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Malta",
    callingCodes: "+356",
    flags: {
      svg: "https://flagcdn.com/mt.svg",
      png: "https://flagcdn.com/w320/mt.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Marshall Islands",
    callingCodes: "+692",
    flags: {
      svg: "https://flagcdn.com/mh.svg",
      png: "https://flagcdn.com/w320/mh.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Martinique",
    callingCodes: "+596",
    flags: {
      svg: "https://flagcdn.com/mq.svg",
      png: "https://flagcdn.com/w320/mq.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Mauritania",
    callingCodes: "+222",
    flags: {
      svg: "https://flagcdn.com/mr.svg",
      png: "https://flagcdn.com/w320/mr.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Mauritius",
    callingCodes: "+230",
    flags: {
      svg: "https://flagcdn.com/mu.svg",
      png: "https://flagcdn.com/w320/mu.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Mayotte",
    callingCodes: "+262",
    flags: {
      svg: "https://flagcdn.com/yt.svg",
      png: "https://flagcdn.com/w320/yt.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Mexico",
    callingCodes: "+52",
    flags: {
      svg: "https://flagcdn.com/mx.svg",
      png: "https://flagcdn.com/w320/mx.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Micronesia (Federated States of)",
    callingCodes: "+691",
    flags: {
      svg: "https://flagcdn.com/fm.svg",
      png: "https://flagcdn.com/w320/fm.png",
    },
    independent: false,
  },
  {
    name: "Moldova (Republic of)",
    callingCodes: "+373",
    flags: {
      svg: "https://flagcdn.com/md.svg",
      png: "https://flagcdn.com/w320/md.png",
    },
    independent: false,
  },
  {
    name: "Monaco",
    callingCodes: "+377",
    flags: {
      svg: "https://flagcdn.com/mc.svg",
      png: "https://flagcdn.com/w320/mc.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Mongolia",
    callingCodes: "+976",
    flags: {
      svg: "https://flagcdn.com/mn.svg",
      png: "https://flagcdn.com/w320/mn.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Montenegro",
    callingCodes: "+382",
    flags: {
      svg: "https://flagcdn.com/me.svg",
      png: "https://flagcdn.com/w320/me.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Montserrat",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/ms.svg",
      png: "https://flagcdn.com/w320/ms.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Morocco",
    callingCodes: "+212",
    flags: {
      svg: "https://flagcdn.com/ma.svg",
      png: "https://flagcdn.com/w320/ma.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Mozambique",
    callingCodes: "+258",
    flags: {
      svg: "https://flagcdn.com/mz.svg",
      png: "https://flagcdn.com/w320/mz.png",
    },
    independent: false,
    phoneLength: 12,
  },
  {
    name: "Myanmar",
    callingCodes: "+95",
    flags: {
      svg: "https://flagcdn.com/mm.svg",
      png: "https://flagcdn.com/w320/mm.png",
    },
    independent: false,
  },
  {
    name: "Namibia",
    callingCodes: "+264",
    flags: {
      svg: "https://flagcdn.com/na.svg",
      png: "https://flagcdn.com/w320/na.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Nauru",
    callingCodes: "+674",
    flags: {
      svg: "https://flagcdn.com/nr.svg",
      png: "https://flagcdn.com/w320/nr.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Nepal",
    callingCodes: "+977",
    flags: {
      svg: "https://flagcdn.com/np.svg",
      png: "https://flagcdn.com/w320/np.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Netherlands",
    callingCodes: "+31",
    flags: {
      svg: "https://flagcdn.com/nl.svg",
      png: "https://flagcdn.com/w320/nl.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "New Caledonia",
    callingCodes: "+687",
    flags: {
      svg: "https://flagcdn.com/nc.svg",
      png: "https://flagcdn.com/w320/nc.png",
    },
    independent: false,
    phoneLength: 6,
  },
  {
    name: "New Zealand",
    callingCodes: "+64",
    flags: {
      svg: "https://flagcdn.com/nz.svg",
      png: "https://flagcdn.com/w320/nz.png",
    },
    independent: false,
    phoneLength: [8, 9],
  },
  {
    name: "Nicaragua",
    callingCodes: "+505",
    flags: {
      svg: "https://flagcdn.com/ni.svg",
      png: "https://flagcdn.com/w320/ni.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Niger",
    callingCodes: "+227",
    flags: {
      svg: "https://flagcdn.com/ne.svg",
      png: "https://flagcdn.com/w320/ne.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Nigeria",
    callingCodes: "+234",
    flags: {
      svg: "https://flagcdn.com/ng.svg",
      png: "https://flagcdn.com/w320/ng.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Niue",
    callingCodes: "+683",
    flags: {
      svg: "https://flagcdn.com/nu.svg",
      png: "https://flagcdn.com/w320/nu.png",
    },
    independent: false,
    phoneLength: 4,
  },
  {
    name: "Norfolk Island",
    callingCodes: "+672",
    flags: {
      svg: "https://flagcdn.com/nf.svg",
      png: "https://flagcdn.com/w320/nf.png",
    },
    independent: false,
    phoneLength: 6,
  },
  {
    name: "Korea (Democratic People's Republic of)",
    callingCodes: "+850",
    flags: {
      svg: "https://flagcdn.com/kp.svg",
      png: "https://flagcdn.com/w320/kp.png",
    },
    independent: false,
  },
  {
    name: "Northern Mariana Islands",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/mp.svg",
      png: "https://flagcdn.com/w320/mp.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Norway",
    callingCodes: "+47",
    flags: {
      svg: "https://flagcdn.com/no.svg",
      png: "https://flagcdn.com/w320/no.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Oman",
    callingCodes: "+968",
    flags: {
      svg: "https://flagcdn.com/om.svg",
      png: "https://flagcdn.com/w320/om.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Pakistan",
    callingCodes: "+92",
    flags: {
      svg: "https://flagcdn.com/pk.svg",
      png: "https://flagcdn.com/w320/pk.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Palau",
    callingCodes: "+680",
    flags: {
      svg: "https://flagcdn.com/pw.svg",
      png: "https://flagcdn.com/w320/pw.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Palestine, State of",
    callingCodes: "+970",
    flags: {
      svg: "https://flagcdn.com/ps.svg",
      png: "https://flagcdn.com/w320/ps.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Panama",
    callingCodes: "+507",
    flags: {
      svg: "https://flagcdn.com/pa.svg",
      png: "https://flagcdn.com/w320/pa.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Papua New Guinea",
    callingCodes: "+675",
    flags: {
      svg: "https://flagcdn.com/pg.svg",
      png: "https://flagcdn.com/w320/pg.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Paraguay",
    callingCodes: "+595",
    flags: {
      svg: "https://flagcdn.com/py.svg",
      png: "https://flagcdn.com/w320/py.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Peru",
    callingCodes: "+51",
    flags: {
      svg: "https://flagcdn.com/pe.svg",
      png: "https://flagcdn.com/w320/pe.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Philippines",
    callingCodes: "+63",
    flags: {
      svg: "https://flagcdn.com/ph.svg",
      png: "https://flagcdn.com/w320/ph.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Pitcairn",
    callingCodes: "+64",
    flags: {
      svg: "https://flagcdn.com/pn.svg",
      png: "https://flagcdn.com/w320/pn.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Poland",
    callingCodes: "+48",
    flags: {
      svg: "https://flagcdn.com/pl.svg",
      png: "https://flagcdn.com/w320/pl.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Portugal",
    callingCodes: "+351",
    flags: {
      svg: "https://flagcdn.com/pt.svg",
      png: "https://flagcdn.com/w320/pt.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Puerto Rico",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/pr.svg",
      png: "https://flagcdn.com/w320/pr.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Qatar",
    callingCodes: "+974",
    flags: {
      svg: "https://flagcdn.com/qa.svg",
      png: "https://flagcdn.com/w320/qa.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Republic of Kosovo",
    callingCodes: "+383",
    flags: {
      svg: "https://flagcdn.com/xk.svg",
      png: "https://flagcdn.com/w320/xk.png",
    },
    independent: false,
  },
  {
    name: "Réunion",
    callingCodes: "+262",
    flags: {
      svg: "https://flagcdn.com/re.svg",
      png: "https://flagcdn.com/w320/re.png",
    },
    independent: false,
  },
  {
    name: "Romania",
    callingCodes: "+40",
    flags: {
      svg: "https://flagcdn.com/ro.svg",
      png: "https://flagcdn.com/w320/ro.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Russian Federation",
    callingCodes: "+7",
    flags: {
      svg: "https://flagcdn.com/ru.svg",
      png: "https://flagcdn.com/w320/ru.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Rwanda",
    callingCodes: "+250",
    flags: {
      svg: "https://flagcdn.com/rw.svg",
      png: "https://flagcdn.com/w320/rw.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Saint Barthélemy",
    callingCodes: "+590",
    flags: {
      svg: "https://flagcdn.com/bl.svg",
      png: "https://flagcdn.com/w320/bl.png",
    },
    independent: false,
  },
  {
    name: "Saint Helena, Ascension and Tristan da Cunha",
    callingCodes: "+290",
    flags: {
      svg: "https://flagcdn.com/sh.svg",
      png: "https://flagcdn.com/w320/sh.png",
    },
    independent: false,
  },
  {
    name: "Saint Kitts and Nevis",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/kn.svg",
      png: "https://flagcdn.com/w320/kn.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Saint Lucia",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/lc.svg",
      png: "https://flagcdn.com/w320/lc.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Saint Martin (French part)",
    callingCodes: "+590",
    flags: {
      svg: "https://flagcdn.com/mf.svg",
      png: "https://flagcdn.com/w320/mf.png",
    },
    independent: false,
    phoneLength: 6,
  },
  {
    name: "Saint Pierre and Miquelon",
    callingCodes: "+508",
    flags: {
      svg: "https://flagcdn.com/pm.svg",
      png: "https://flagcdn.com/w320/pm.png",
    },
    independent: false,
    phoneLength: 6,
  },
  {
    name: "Saint Vincent and the Grenadines",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/vc.svg",
      png: "https://flagcdn.com/w320/vc.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Samoa",
    callingCodes: "+685",
    flags: {
      svg: "https://flagcdn.com/ws.svg",
      png: "https://flagcdn.com/w320/ws.png",
    },
    independent: false,
    phoneLength: [5, 6, 7],
  },
  {
    name: "San Marino",
    callingCodes: "+378",
    flags: {
      svg: "https://flagcdn.com/sm.svg",
      png: "https://flagcdn.com/w320/sm.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Sao Tome and Principe",
    callingCodes: "+239",
    flags: {
      svg: "https://flagcdn.com/st.svg",
      png: "https://flagcdn.com/w320/st.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Saudi Arabia",
    callingCodes: "+966",
    flags: {
      svg: "https://flagcdn.com/sa.svg",
      png: "https://flagcdn.com/w320/sa.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Senegal",
    callingCodes: "+221",
    flags: {
      svg: "https://flagcdn.com/sn.svg",
      png: "https://flagcdn.com/w320/sn.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Serbia",
    callingCodes: "+381",
    flags: {
      svg: "https://flagcdn.com/rs.svg",
      png: "https://flagcdn.com/w320/rs.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Seychelles",
    callingCodes: "+248",
    flags: {
      svg: "https://flagcdn.com/sc.svg",
      png: "https://flagcdn.com/w320/sc.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Sierra Leone",
    callingCodes: "+232",
    flags: {
      svg: "https://flagcdn.com/sl.svg",
      png: "https://flagcdn.com/w320/sl.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Singapore",
    callingCodes: "+65",
    flags: {
      svg: "https://flagcdn.com/sg.svg",
      png: "https://flagcdn.com/w320/sg.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Sint Maarten (Dutch part)",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/sx.svg",
      png: "https://flagcdn.com/w320/sx.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Slovakia",
    callingCodes: "+421",
    flags: {
      svg: "https://flagcdn.com/sk.svg",
      png: "https://flagcdn.com/w320/sk.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Slovenia",
    callingCodes: "+386",
    flags: {
      svg: "https://flagcdn.com/si.svg",
      png: "https://flagcdn.com/w320/si.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Solomon Islands",
    callingCodes: "+677",
    flags: {
      svg: "https://flagcdn.com/sb.svg",
      png: "https://flagcdn.com/w320/sb.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Somalia",
    callingCodes: "+252",
    flags: {
      svg: "https://flagcdn.com/so.svg",
      png: "https://flagcdn.com/w320/so.png",
    },
    independent: false,
    phoneLength: [8, 9],
  },
  {
    name: "South Africa",
    callingCodes: "+27",
    flags: {
      svg: "https://flagcdn.com/za.svg",
      png: "https://flagcdn.com/w320/za.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    callingCodes: "+500",
    flags: {
      svg: "https://flagcdn.com/gs.svg",
      png: "https://flagcdn.com/w320/gs.png",
    },
    independent: false,
    phoneLength: 5,
  },
  {
    name: "Korea (Republic of)",
    callingCodes: "+82",
    flags: {
      svg: "https://flagcdn.com/kr.svg",
      png: "https://flagcdn.com/w320/kr.png",
    },
    independent: false,
  },
  {
    name: "Spain",
    callingCodes: "+34",
    flags: {
      svg: "https://flagcdn.com/es.svg",
      png: "https://flagcdn.com/w320/es.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Sri Lanka",
    callingCodes: "+94",
    flags: {
      svg: "https://flagcdn.com/lk.svg",
      png: "https://flagcdn.com/w320/lk.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Sudan",
    callingCodes: "+249",
    flags: {
      svg: "https://flagcdn.com/sd.svg",
      png: "https://flagcdn.com/w320/sd.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "South Sudan",
    callingCodes: "+211",
    flags: {
      svg: "https://flagcdn.com/ss.svg",
      png: "https://flagcdn.com/w320/ss.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Suriname",
    callingCodes: "+597",
    flags: {
      svg: "https://flagcdn.com/sr.svg",
      png: "https://flagcdn.com/w320/sr.png",
    },
    independent: false,
    phoneLength: [6, 7],
  },
  {
    name: "Svalbard and Jan Mayen",
    callingCodes: "+47",
    flags: {
      svg: "https://flagcdn.com/sj.svg",
      png: "https://flagcdn.com/w320/sj.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Swaziland",
    callingCodes: "+268",
    flags: {
      svg: "https://flagcdn.com/sz.svg",
      png: "https://flagcdn.com/w320/sz.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Sweden",
    callingCodes: "+46",
    flags: {
      svg: "https://flagcdn.com/se.svg",
      png: "https://flagcdn.com/w320/se.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Switzerland",
    callingCodes: "+41",
    flags: {
      svg: "https://flagcdn.com/ch.svg",
      png: "https://flagcdn.com/w320/ch.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Syrian Arab Republic",
    callingCodes: "+963",
    flags: {
      svg: "https://flagcdn.com/sy.svg",
      png: "https://flagcdn.com/w320/sy.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Taiwan",
    callingCodes: "+886",
    flags: {
      svg: "https://flagcdn.com/tw.svg",
      png: "https://flagcdn.com/w320/tw.png",
    },
    independent: false,
  },
  {
    name: "Tajikistan",
    callingCodes: "+992",
    flags: {
      svg: "https://flagcdn.com/tj.svg",
      png: "https://flagcdn.com/w320/tj.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Tanzania, United Republic of",
    callingCodes: "+255",
    flags: {
      svg: "https://flagcdn.com/tz.svg",
      png: "https://flagcdn.com/w320/tz.png",
    },
    independent: false,
  },
  {
    name: "Thailand",
    callingCodes: "+66",
    flags: {
      svg: "https://flagcdn.com/th.svg",
      png: "https://flagcdn.com/w320/th.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Timor-Leste",
    callingCodes: "+670",
    flags: {
      svg: "https://flagcdn.com/tl.svg",
      png: "https://flagcdn.com/w320/tl.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Togo",
    callingCodes: "+228",
    flags: {
      svg: "https://flagcdn.com/tg.svg",
      png: "https://flagcdn.com/w320/tg.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Tokelau",
    callingCodes: "+690",
    flags: {
      svg: "https://flagcdn.com/tk.svg",
      png: "https://flagcdn.com/w320/tk.png",
    },
    independent: false,
    phoneLength: 5,
  },
  {
    name: "Tonga",
    callingCodes: "+676",
    flags: {
      svg: "https://flagcdn.com/to.svg",
      png: "https://flagcdn.com/w320/to.png",
    },
    independent: false,
    phoneLength: 5,
  },
  {
    name: "Trinidad and Tobago",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/tt.svg",
      png: "https://flagcdn.com/w320/tt.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Tunisia",
    callingCodes: "+216",
    flags: {
      svg: "https://flagcdn.com/tn.svg",
      png: "https://flagcdn.com/w320/tn.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Turkey",
    callingCodes: "+90",
    flags: {
      svg: "https://flagcdn.com/tr.svg",
      png: "https://flagcdn.com/w320/tr.png",
    },
    independent: false,
    phoneLength: 11,
  },
  {
    name: "Turkmenistan",
    callingCodes: "+993",
    flags: {
      svg: "https://flagcdn.com/tm.svg",
      png: "https://flagcdn.com/w320/tm.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Turks and Caicos Islands",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/tc.svg",
      png: "https://flagcdn.com/w320/tc.png",
    },
    independent: false,
    phoneLength: 10,
  },
  {
    name: "Tuvalu",
    callingCodes: "+688",
    flags: {
      svg: "https://flagcdn.com/tv.svg",
      png: "https://flagcdn.com/w320/tv.png",
    },
    independent: false,
    phoneLength: 5,
  },
  {
    name: "Uganda",
    callingCodes: "+256",
    flags: {
      svg: "https://flagcdn.com/ug.svg",
      png: "https://flagcdn.com/w320/ug.png",
    },
    independent: false,
    phoneLength: 7,
  },
  {
    name: "Ukraine",
    callingCodes: "+380",
    flags: {
      svg: "https://flagcdn.com/ua.svg",
      png: "https://flagcdn.com/w320/ua.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "United Arab Emirates",
    callingCodes: "+971",
    flags: {
      svg: "https://flagcdn.com/ae.svg",
      png: "https://flagcdn.com/w320/ae.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "United Kingdom of Great Britain and Northern Ireland",
    callingCodes: "+44",
    flags: {
      svg: "https://flagcdn.com/gb.svg",
      png: "https://flagcdn.com/w320/gb.png",
    },
    independent: false,
  },
  {
    name: "United States of America",
    callingCodes: "+1",
    flags: {
      svg: "https://flagcdn.com/us.svg",
      png: "https://flagcdn.com/w320/us.png",
    },
    independent: false,
  },
  {
    name: "Uruguay",
    callingCodes: "+598",
    flags: {
      svg: "https://flagcdn.com/uy.svg",
      png: "https://flagcdn.com/w320/uy.png",
    },
    independent: false,
    phoneLength: 8,
  },
  {
    name: "Uzbekistan",
    callingCodes: "+998",
    flags: {
      svg: "https://flagcdn.com/uz.svg",
      png: "https://flagcdn.com/w320/uz.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Vanuatu",
    callingCodes: "+678",
    flags: {
      svg: "https://flagcdn.com/vu.svg",
      png: "https://flagcdn.com/w320/vu.png",
    },
    independent: false,
    phoneLength: 5,
  },
  {
    name: "Venezuela (Bolivarian Republic of)",
    callingCodes: "+58",
    flags: {
      svg: "https://flagcdn.com/ve.svg",
      png: "https://flagcdn.com/w320/ve.png",
    },
    independent: false,
  },
  {
    name: "Vietnam",
    callingCodes: "+84",
    flags: {
      svg: "https://flagcdn.com/vn.svg",
      png: "https://flagcdn.com/w320/vn.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Wallis and Futuna",
    callingCodes: "+681",
    flags: {
      svg: "https://flagcdn.com/wf.svg",
      png: "https://flagcdn.com/w320/wf.png",
    },
    independent: false,
    phoneLength: 6,
  },
  {
    name: "Western Sahara",
    callingCodes: "+212",
    flags: {
      svg: "https://flagcdn.com/eh.svg",
      png: "https://flagcdn.com/w320/eh.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Yemen",
    callingCodes: "+967",
    flags: {
      svg: "https://flagcdn.com/ye.svg",
      png: "https://flagcdn.com/w320/ye.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Zambia",
    callingCodes: "+260",
    flags: {
      svg: "https://flagcdn.com/zm.svg",
      png: "https://flagcdn.com/w320/zm.png",
    },
    independent: false,
    phoneLength: 9,
  },
  {
    name: "Zimbabwe",
    callingCodes: "+263",
    flags: {
      svg: "https://flagcdn.com/zw.svg",
      png: "https://flagcdn.com/w320/zw.png",
    },
    independent: false,
    phoneLength: 9,
  },
];
